export default "__VITE_ASSET__3Senih7K__"